import React from 'react';

import { RemoteConfigKey } from '../../../config/remote-config.config';
import useRemoteValue from '../../../hooks/remote-value/remote-value.hook';
import MaintenanceComponent from './maintenance.component';

export const MaintenanceGate: React.FC = ({ children }) => {
  const { value: isUnderMaintenance } = useRemoteValue(RemoteConfigKey.MaintenanceMode);

  if (isUnderMaintenance) {
    return <MaintenanceComponent />;
  }

  return <>{children}</>;
};

export default MaintenanceGate;
